import React from "react";

import CallPopup from "../call/CallPopup";
import MeetingPopup from "../meeting/MeetingPopup";
import DocumentPopup from "../meeting/DocumentPopup";
import SmsPopup from "../sms/SmsPopup";
import EmailPopup from "../email/EmailPopup";
import WhatsAppPopup from "../whatsapp/WhatsAppPopup";
import LeadContactPopup from "../contact/LeadContactPopup";
import CloudCallPopup from "../call/CloudCallPopup";
import LeadConst from "../../util/LeadConst";
import NotePopup from "../note/NotePopup";

class LeadPreviewPopUpList extends React.Component {
  render() {
    const props = { ...this.props };
    return (
      <>
        {props.CallAdd || props.CallUpdate ? (
          <CallPopup
            show={props.popup === LeadConst.Call}
            onHide={props.hidePopUp}
            call={props.call}
            reload={props.updateMater}
            model_no={props.module}
            model_id={props.id}
            lead={props.lead}
          />
        ) : null}

        {props.MeetAdd || props.MeetUpdate ? (
          <MeetingPopup
            show={props.popup === LeadConst.Meeting}
            onHide={props.hidePopUp}
            meeting={props.meeting}
            contacts={props.contacts}
            reload={props.updateMater}
            model_no={props.module}
            model_id={props.id}
            lead={props.lead}
          />
        ) : null}

        {props.DocAdd ? (
          <DocumentPopup
            show={props.popup === LeadConst.Document}
            onHide={props.hidePopUp}
            meeting={props.document}
            reload={props.updateMater}
            model_no={props.module}
            model_id={props.id}
          />
        ) : null}

        {props.SmsAdd ? (
          <SmsPopup
            show={props.popup === LeadConst.SMS}
            onHide={props.hidePopUp}
            data={props.lead}
            model={props.model}
            reload={props.updateMater}
            model_no={props.module}
            model_id={props.id}
          />
        ) : null}

        {props.EmailAdd ? (
          <EmailPopup
            show={props.popup === LeadConst.Email}
            onHide={props.hidePopUp}
            data={props.lead}
            model={props.model}
            reload={props.updateMater}
            model_no={props.module}
            model_id={props.id}
          />
        ) : null}

        {props.ContactAdd ? (
          <LeadContactPopup
            show={props.popup === LeadConst.Contact}
            onHide={props.hidePopUp}
            data={props.lead}
            model={props.model}
            addContact={props.addContact}
            redirect={props.redirectAddContact}
            model_no={props.module}
            model_id={props.id}
          />
        ) : null}

        {props.CloudCall ? (
          <CloudCallPopup
            show={props.popup === LeadConst.CloudCall}
            onHide={props.hidePopUp}
            data={props.lead}
            model={props.model}
            modelNo={props.module}
            modelId={props.id}
            addCall={props.showPopUp}
          />
        ) : null}
        {props.NoteAdd ? (
          <NotePopup
            show={this.props.popup === LeadConst.Note}
            onHide={props.hidePopUp}
            reload={props.updateMater}
            note={props.note}
            model={props.model}
            model_no={props.module}
            model_id={props.id}
          />
        ) : null}

        {props.whatsAppAdd ? (<WhatsAppPopup
          show={props.popup === LeadConst.WhatsApp}
          onHide={props.hidePopUp}
          reload={props.updateMater}
          data={props.lead}
          model={props.model}
        />) : null}
      </>
    );
  }
}
export default LeadPreviewPopUpList;